export default __webpack_public_path__ + "static/media/icon-card-trend-monitoring.ef9b7677.svg";